import React from "react";
import { Avatar, Button, Group, Text } from "@mantine/core";
import { Logout, Terminal } from "tabler-icons-react";

const Welcome = ({ user, handleSignOut }) => {
  const name = user?.user_metadata?.full_name || user?.email || "Operator";

  return (
    <header className="app-header">
      <a href="/" className="app-header__home" aria-label="Go to home screen">
        <div className="app-header__mark">
          <Terminal size={18} />
        </div>
        <div>
          <Text className="app-header__eyebrow">Bugsjoy</Text>
          <Text className="app-header__title">Debug console</Text>
        </div>
        <span className="live-badge">
          <span />
          live
        </span>
      </a>
      <Group spacing={10}>
        <Avatar size={28} radius="xl" src={user?.user_metadata?.avatar_url} />
        <Text className="app-header__user">{name}</Text>
        <Button
          variant="subtle"
          compact
          leftIcon={<Logout size={15} />}
          onClick={handleSignOut}
          className="toolbar-button"
        >
          Logout
        </Button>
      </Group>
    </header>
  );
};

export default Welcome;
